module.exports = __webpack_public_path__ + "static/media/CircularStd-Book.35e6fb86.woff2";